//Formik
import { useField } from "formik"

//PrimeReact
import { Skeleton } from "primereact/skeleton"
import { InputTextarea } from "primereact/inputtextarea"

//Style
import styles from "../../styles/Form-Inputs.module.css"

import CustomTooltip from "../CustomTooltip"

export default function FormikTextAreaInput({
  name,
  label,
  placeholderText,
  required,
  isInitialLoad,
  rows,
  disabled,
  helpText,
  info_id,
}) {
  const [field, meta] = useField(name)

  let placeholder = placeholderText
  if (required && !placeholder) {
    placeholder = name
  }

  const inputfield = () => {
    if (isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else {
      return (
        <InputTextarea
          placeholder={placeholder}
          {...field}
          required={required}
          disabled={disabled}
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          style={{ width: "100%", height: "100%" }}
          rows={rows}
        />
      )
    }
  }

  const labelField = () => {
    if (isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return (
        <>
          <CustomTooltip
            label={
              helpText
                ? helpText
                : `Hover over the icon to get more information about ${label}`
            }
            position={"right"}
            targetId={info_id}
          />
          <label className={styles.label}>
            {label}
            {
              <i
                className={`pi pi-info-circle ${styles.info} ${styles.infoIcon}`}
                id={info_id}
              ></i>
            }
          </label>
        </>
      )
    }
  }

  return (
    <div className={styles.field}>
      {labelField()}
      <div className="w-full">
        {inputfield()}
        {meta.touched && meta.error ? (
          <label id={`${name}-error`} className={styles.errFieldMsg}>
            {meta.error}
          </label>
        ) : null}
      </div>
    </div>
  )
}
